module.exports = __webpack_public_path__ + "apres-midi.5b8611b033d9f18bfac9a72f1088c040.png";